export const CandidateData = [
  {
    id: 1,
    name: "Vivek Desai",
    post: "Secretary",
    voted: false
  },
  {
    id: 2,
    name: "Shiv Choudhary",
    post: "Secretary",
    voted: false
  },
  {
    id: 3,
    name: "Vishwajeet Kulkarni",
    post: "Secretary",
    voted: false
  },
];
